<template>
  <span v-if="count == 0">
    {{ $t("cart.noCartElements") }}
  </span>
  <span v-else-if="count == 1"> Hai <b>1 prodotto</b> nel carrello </span>
  <span v-else>
    Hai <span class="font-weight-bold">{{ count }} prodotti</span> nel carrello
  </span>
</template>
<script>
export default {
  name: "CartItemCount",
  props: {
    count: { required: false, type: Number }
  }
};
</script>
